// 모듈 로더 — 활성 모듈의 매니페스트를 모아 Core 라우터/스토어/네비에 주입한다.
import history from "@modules/history";
import remote from "@modules/remote";
import check from "@modules/check";

export const activeModules = [history, remote, check];

// 라우터: AppShell children 에 모든 모듈 라우트 주입
//   children: [ ...activeModules.flatMap((m) => m.routes) ]
//
// 스토어: 모듈 스토어 병합
//   activeModules.forEach((m) => store.registerModule(m.code, m.store));
